import React from "react";

import "./loading.css";

function Loading() {
  return (
    <div className="load_box">
      <div class="loader"></div>
    </div>
  );
}

export default Loading;
